"use client";

import { Avatar, AvatarFallback, AvatarImage } from "@gerama/ui";
import type { SiteUser } from "@gerama/types";
import { cn } from "@gerama/utils";

/** First letter of the name, or a neutral mark when there is none. */
export function userInitial(user: Pick<SiteUser, "name">): string {
  return (user.name ?? "").trim().charAt(0) || "؟";
}

/** What to show under the name: the phone (LTR digits) or the email. */
export function userSubtitle(user: Pick<SiteUser, "phone" | "email">): string | null {
  return user.phone ?? user.email ?? null;
}

/**
 * The listener's avatar — their photo (uploaded, or picked up from Google),
 * falling back to the initial on a primary circle while it loads or when
 * there is none. `large` uses the 500px rendition for big displays.
 */
export function UserAvatar({
  user,
  large = false,
  className,
  fallbackClassName,
}: {
  user: Pick<SiteUser, "name" | "photo" | "photoLarge">;
  large?: boolean;
  className?: string;
  fallbackClassName?: string;
}) {
  const src = (large ? user.photoLarge : null) ?? user.photo ?? undefined;
  return (
    <Avatar className={cn("size-8", className)}>
      {src && (
        <AvatarImage
          src={src}
          alt={user.name ?? "تصویر پروفایل"}
          className="object-cover"
          referrerPolicy="no-referrer"
        />
      )}
      <AvatarFallback
        className={cn("bg-primary text-primary-foreground font-bold", fallbackClassName)}
      >
        {userInitial(user)}
      </AvatarFallback>
    </Avatar>
  );
}
